import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

interface HrisOverviewModel {
  isGlobal: boolean;
  isReadOnly: boolean;
}

export default class LocationOverviewHrisController extends Controller {
  @tracked declare model: HrisOverviewModel;

  get isGlobal(): boolean {
    return this.model?.isGlobal ?? false;
  }

  get isReadOnly(): boolean {
    return this.model?.isReadOnly ?? true;
  }
}
